import { defineMessages, MessageDescriptor } from 'react-intl';

export const benefitsModalTableMessages: {
  [key: string]: MessageDescriptor;
} = defineMessages({
  notChosen: {
    id: 'pd.loyalty.benefits.modal.table.not.chosen',
    defaultMessage: 'nevybráno',
  },
  ok: {
    id: 'pd.loyalty.benefits.modal.ok',
    defaultMessage: 'Ok',
  },
  settings: {
    id: 'pd.loyalty.benefits.modal.settings',
    defaultMessage: 'Nastavení',
  },
});
